const openJumpInput = button => {
    const input = button.closest('.pagination-jump').querySelector('input');

    button.hidden = true;
    input.hidden = false;
    input.focus();
};

const closeJumpInput = input => {
    input.value = '';
    input.classList.remove('error');
    input.hidden = true;
    input.closest('.pagination-jump').querySelector('button').hidden = false;
};

const submitJump = form => {
    const input = form.querySelector('input');
    const page = input.value.trim();

    if (!/^\d+$/.test(page)) {
        input.classList.add('error');
        return;
    }

    window.location.assign(form.getAttribute('action').replace(/(sort(?:\.[\w.]+)?=[^&]*)%7C\d+/, '$1%7C' + page));
};

const changePerPage = select => {
    const url = new URL(select.form.action, window.location.origin);
    const data = new FormData();

    url.searchParams.set('per_page', select.value);
    data.set('perPage', select.value);

    fetch(select.form.dataset.perPageUrl, {
        method: 'post',
        body: data,
        keepalive: true,
    });

    window.location.assign(url);
};

export {changePerPage, closeJumpInput, openJumpInput, submitJump};
